import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { LoadingPlugin } from 'vue-loading-overlay'

import App from './App.vue'
import router from './router'
import 'vue-loading-overlay/dist/css/index.css'
import { createHead } from '@vueuse/head'

import * as Sentry from '@sentry/vue'

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const head = createHead()
app.use(head)

app.use(pinia)
app.use(router)
app.use(LoadingPlugin)

Sentry.init({
	app,
	dsn: 'https://96a182737740f4cb6cf7ea01ee09f419@o4507330308931584.ingest.us.sentry.io/4509447934705664',
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: true
})

app.mount('#app')
